'use client';

import { useEscapeKey } from '@/hooks/useEscapeKey';

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = 'Delete',
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  useEscapeKey(onCancel, open);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-base-100/95" onClick={onCancel} />
      <div className="relative bg-base-100 border border-base-300/30 rounded-2xl p-6 w-full max-w-sm mx-4 space-y-4 animate-fade-in shadow-2xl">
        <h3 className="text-base font-bold">{title}</h3>
        <p className="text-sm text-base-content/50">{message}</p>
        <div className="flex items-center justify-end gap-2">
          <button onClick={onCancel} className="btn btn-ghost btn-sm">Cancel</button>
          <button onClick={onConfirm} className="btn btn-error btn-sm">{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}
